import Link from "next/link";
import React from "react";
import { FaChartLine, FaCoins } from "react-icons/fa6";
import { RiMoneyDollarCircleFill } from "react-icons/ri";
const RevenueCard = ({ total, currentMonth, pastThreeMonths }) => (
  <div className="dark:bg-jacarta-800 bg-white rounded-2xl p-5 shadow-sm hover:shadow-lg transition-all h-full relative overflow-hidden">
    {/* Coming Soon Overlay */}
    <div className="absolute inset-0 bg-jacarta-900/80 backdrop-blur-sm z-20 flex flex-col items-center justify-center">
      <div className="bg-accent/20 p-3 rounded-full mb-3">
        <RiMoneyDollarCircleFill className="text-accent text-3xl" />
      </div>
      <h4 className="text-white font-display text-lg mb-2">Coming Soon</h4>
      <p className="text-jacarta-300 text-sm text-center max-w-[200px]">
        Revenue tracking and analytics coming soon!
      </p>
    </div>

    <div className="flex items-center justify-between mb-2">
      <div className="flex items-center gap-2">
        <RiMoneyDollarCircleFill className="text-accent text-xl" />
        <h3 className="text-base font-display">Revenue Overview</h3>
      </div>
      <Link
        href="/dashboard/revenue"
        className="text-xs text-jacarta-800 dark:text-accent"
      >
        View Details →
      </Link>
    </div>

    <div className="mt-3 space-y-3 relative z-10">
      <div className="bg-jacarta-50 dark:bg-jacarta-700/50 rounded-xl p-4 backdrop-blur-sm">
        <div className="flex items-center gap-2">
          <p className="text-2xl font-bold text-jacarta-700 dark:text-white">
            ${total?.toLocaleString()}
          </p>
          <span className="text-xs px-2 py-1 bg-green-500/10 text-green-500 rounded-lg">
            +12.5%
          </span>
        </div>
        <p className="text-sm text-jacarta-700 dark:text-jacarta-300">
          Total Revenue
        </p>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div className="bg-jacarta-50 dark:bg-jacarta-700/50 p-3 rounded-xl backdrop-blur-sm">
          <div className="flex items-center gap-2 mb-1">
            <span className="text-xs px-2 py-1 bg-accent/10 text-accent rounded-lg">
              <FaCoins className="inline-block" />
            </span>
            <p className="text-lg font-semibold dark:text-accent">
              ${currentMonth?.toLocaleString()}
            </p>
          </div>
          <p className="text-xs text-jacarta-700 dark:text-jacarta-300">
            This Month
          </p>
        </div>
        <div className="bg-jacarta-50 dark:bg-jacarta-700/50 p-3 rounded-xl backdrop-blur-sm">
          <div className="flex items-center gap-2 mb-1">
            <span className="text-xs px-2 py-1 bg-accent/10 text-accent rounded-lg">
              <FaChartLine className="inline-block" />
            </span>
            <p className="text-lg font-semibold dark:text-accent">
              ${pastThreeMonths?.toLocaleString()}
            </p>
          </div>
          <p className="text-xs text-jacarta-700 dark:text-jacarta-300">
            Past 3 Months
          </p>
        </div>
      </div>

      <div className="mt-3 p-3 bg-jacarta-50 dark:bg-jacarta-700/50 rounded-xl backdrop-blur-sm">
        <div className="flex items-center justify-between">
          <span className="text-sm text-jacarta-700 dark:text-jacarta-300">
            Monthly Target
          </span>
          <span className="text-sm text-accent">92%</span>
        </div>
        <div className="w-full h-2 bg-jacarta-200 dark:bg-jacarta-600 rounded-full mt-2">
          <div
            className="h-full bg-accent rounded-full"
            style={{ width: "92%" }}
          />
        </div>
      </div>
    </div>
  </div>
);
export default RevenueCard;
